var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.9 245.7",
    style: {
      enableBackground: "new 0 0 318.9 245.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000156573066587751630950000015178574082444412846_);}\n\t.st3{fill:url(#SVGID_00000063622321025236459150000015066998366753826971_);}\n\t.st4{fill:url(#SVGID_00000147215542240912249720000015756045278502053763_);}\n\t.st5{fill:url(#SVGID_00000085248042040564123330000015383114021433003685_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.9,196.1c0,27.4-22.2,49.6-49.6,49.6H0V49.6C0,22.2,22.2,0,49.6,0h269.3V196.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.0452,
    y1: 135.7791,
    x2: 400.937,
    y2: 135.7791,
    gradientTransform: "matrix(1.125 0 0 1.125 -149.6462 -16.2613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#008D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#4FAC48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62BB46"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.1,145.8h20.5c0.6,0,1.9-0.1,2.4-0.2c3.9-0.9,7.2-4.3,7.2-9.1c0-4.8-3.3-8.3-7.2-9.1 c-0.6-0.1-1.8-0.2-2.4-0.2h-20.5V145.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150102882665677039230000009983404916569634479_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.044,
    y1: 123.6415,
    x2: 400.9378,
    y2: 123.6415,
    gradientTransform: "matrix(1.125 0 0 1.125 -149.6462 -16.2613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#008D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#4FAC48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62BB46"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150102882665677039230000009983404916569634479_)"
    },
    d: "M249.2,16.5c-19.6,0-35.4,15.9-35.4,35.4 v36.8h50.1c1.2,0,2.6,0.1,3.5,0.1c11.3,0.6,19.7,6.4,19.7,16.5c0,8-5.7,14.7-16.1,16.3v0.4c11.5,0.8,20.3,7.1,20.3,17.1 c0,10.8-9.7,17.7-22.5,17.7h-55v72.2h52c19.6,0,35.4-15.9,35.4-35.4V16.5H249.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001662564466468048860000010506957124722592959_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.0446,
    y1: 110.4297,
    x2: 400.932,
    y2: 110.4297,
    gradientTransform: "matrix(1.125 0 0 1.125 -149.6462 -16.2613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#008D49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#4FAC48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62BB46"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001662564466468048860000010506957124722592959_)"
    },
    d: "M258.8,108c0-4.7-3.3-7.8-7.1-8.5 c-0.4-0.1-1.3-0.2-2-0.2h-18.6v17.3h18.6c0.7,0,1.7-0.1,2-0.2C255.6,115.8,258.8,112.7,258.8,108z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125561069945981948040000006763538423576058550_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.6669,
    y1: 123.6415,
    x2: 227.7633,
    y2: 123.6415,
    gradientTransform: "matrix(1.125 0 0 1.125 -149.6462 -16.2613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#005999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    style: {
      stopColor: "#006FB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077C0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125561069945981948040000006763538423576058550_)"
    },
    d: "M53.2,16.5c-19.6,0-35.4,15.9-35.4,35.4 v87.5c9.9,4.8,20.2,8,30.7,8c12.3,0,19-7.5,19-17.5V88.8h30.5v41.1c0,16.1-9.9,29-43.7,29c-20.4,0-36.4-4.4-36.4-4.4v74.7h52 c19.6,0,35.4-15.9,35.4-35.4V16.5H53.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142889646107242396220000009893242477782337208_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.4406,
    y1: 123.6415,
    x2: 312.2597,
    y2: 123.6415,
    gradientTransform: "matrix(1.125 0 0 1.125 -149.6462 -16.2613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#743237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    style: {
      stopColor: "#8C3039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    style: {
      stopColor: "#BE273F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    style: {
      stopColor: "#DF1E44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED1846"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142889646107242396220000009893242477782337208_)"
    },
    d: "M151.2,16.5c-19.6,0-35.4,15.9-35.4,35.4 v46.4c9-7.7,24.5-12.5,49.7-11.4c13.5,0.6,27.8,4.2,27.8,4.2v15c-7.2-3.6-15.8-7-26.8-7.8c-19.1-1.4-30.7,7.9-30.7,24.5 c0,16.6,11.5,25.9,30.7,24.5c11.1-0.8,19.8-4.3,26.8-7.8v15c0,0-14.3,3.6-27.8,4.2c-25.2,1.1-40.7-3.7-49.7-11.4v81.8h52 c19.6,0,35.4-15.9,35.4-35.4V16.5H151.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.aaa50da774f1dd11e68794abdf648f12.svg";
export { ForwardRef as ReactComponent };